import { defineMessages } from 'react-intl';

export default defineMessages({
    account: {
        id: 'header.links.Account',
        defaultMessage: 'Account'
    },
    faq: {
        id: 'header.links.FAQ',
        defaultMessage: 'FAQ'
    },
    logout: {
        id: 'header.links.Logout',
        defaultMessage: 'Logout'
    },
    myClaims: {
        id: 'header.links.myClaims',
        defaultMessage: 'My Claims'
    },
    myBillings: {
        id: 'header.links.myBillings',
        defaultMessage: 'My Billing'
    },
    home: {
        id: 'header.links.home',
        defaultMessage: 'Home'
    },
    myDocuments: {
        id: 'header.links.myDocuments',
        defaultMessage: 'My Documents'
    },
    reportClaim: {
        id: 'gateway.views.new-quote.Report a Claim',
        defaultMessage: 'Report a Claim'
    },
    makePayment : {
        id: "gateway.views.new-quote.Make a payment",
        defaultMessage: "Make a payment"
      }

});
